import { types } from 'mobx-state-tree';
import type { Instance } from 'mobx-state-tree';

const DisablableComponentsModel = types.model('DisablableComponentsModel', {
    EDUCATOR_SPACE: types.maybeNull(types.boolean),
});
export type TypeDisablableComponentsModel = Instance<typeof DisablableComponentsModel>;

export default DisablableComponentsModel;
